<template>
    <div class="flex-layout mybid-page">
        <list-layout-paper>
            <div slot="header-search">
                <div>
                    <el-input v-model="editorInfo.bidName" placeholder="招标项目名称" size="mini" clearable></el-input>
                    <el-input v-model="editorInfo.bidNo" placeholder="项目编码" size="mini" clearable></el-input>
                    <mSelect class="el-input" :optionNum="'BID_STATUS'" :value="editorInfo.bidStatus" :placeholder="'项目状态'" :filterable="true" @input="getBidStatus"></mSelect>
                    <mSelect class="el-input" :optionNum="'SU_SUPPLIER_BID_STATUS'" :value="editorInfo.supplierBidStatus" :placeholder="'报名状态'" :filterable="true" @input="getSupStatus"></mSelect>
                    <span class="margin-left bigData-btn-search" v-has="'06010001'"><el-button type="primary" size="mini" class="paddingleft" @click="searchFn">查 询</el-button></span>
                </div>
            </div>
            <div slot="header-button" class="header-button">
                <el-tooltip v-if="uniqueVisible" effect="dark" content="生成报价唯一码" placement="bottom" style="margin-left: 10px;">
                    <el-button type="primary" size="mini" :loading="idfLoading" @click="handleIdentify">生成报价唯一码</el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="刷新" placement="bottom" style="margin-left: 10px;">
                    <el-button icon="el-icon-refresh" size="mini" @click="refreshFn"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="列配置" placement="bottom" style="margin-left: 10px;">
                    <el-button icon="el-icon-setting" size="mini" @click="colDispose"></el-button>
                </el-tooltip>
            </div>

            <el-table class="tab-list" slot="list" height="200" v-loading="loading" :data="bidList" @row-dblclick="handleRowDblClick" border stripe ref="table" style="width: 100%">
                <el-table-column v-for="(item, index) in columnsList"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label"
                    :align="'center'"
                    :show-overflow-tooltip="true"
                    :min-width="item.width?item.width : ''">
                    <template slot-scope="scope" >
                        <div v-if="scope.column.label === '招标项目编码'">
                            <span v-if="scope.row.supplierBidStatus === '1' || scope.row.supplierBidStatus === '2' || scope.row.supplierBidStatus === '14'"
                                style="color:#999;">{{scope.row.bidNo}}</span>
                            <span v-else style="color:#00BCBF;cursor:pointer;" @click="handleRowDblClick(scope.row)">{{scope.row.bidNo}}</span>
                        </div>
                        <div v-else-if="scope.column.label === '招标项目名称'">
                            <span>{{scope.row.bidName}}</span>
                            <span v-if="scope.row.isRecall === SRM_YES" class="recall-text">(此招标已废弃)</span>
                        </div>
                        <div v-else-if="scope.column.label === '项目状态'">
                            <span>{{scope.row.bidStatusText}}</span>
                        </div>
                        <div v-else-if="scope.column.label === '报名状态'">
                            <span>{{scope.row.supplierBidStatusText}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="action" label="操作" width="210" align="center" fixed="right">
                    <template slot-scope="scope">
                        <span v-if="scope.row.bidStatus === '30' &&
                            (scope.row.supplierBidStatus === '1' || scope.row.supplierBidStatus === '4')"
                            class="btn-action">等待审核</span>
                        <span v-else-if="scope.row.bidStatus === '30' && scope.row.supplierBidStatus === '2'" v-has="'06010002'">
                            <form id="formCommit" :action="config.mideaPay" method="post">
                                <input type="hidden" :name="key" :value="val"  v-for="(val,key) of payResult" :key="key"/>
                                <span class="buy-bidbook" @click="buyBtn(scope.row, '1')">购买标书</span>
                            </form>
                        </span>
                        <span v-else-if="scope.row.bidStatus === '30' && scope.row.supplierBidStatus === '3' && !scope.row.depositEndTimeFlag" v-has="'06010004'">
                            <el-button @click="bondFn(scope.row)" size="mini" type="text">缴纳投标保证金</el-button>
                        </span>
                        <span v-else-if="scope.row.bidStatus === '30' && (scope.row.supplierBidStatus === '5' ||
                            scope.row.supplierBidStatus === '6' || scope.row.supplierBidStatus === '11')" v-has="'06010003'">
                            <el-button @click="sealFn(scope.row)" size="mini" type="text">应标文件盖章</el-button>
                        </span>
                        <span v-else-if="scope.row.bidStatus === '50' && scope.row.supplierBidStatus === '7' &&
                            scope.row.effectDateFromFlag && scope.row.tenderStatus === '2'" v-has="'06010006'">
                            <el-button size="mini" type="text" @click="toBidding(scope.row)">正在竞价</el-button>
                        </span>
                        <div v-else-if="(scope.row.bidStatus === '50' || scope.row.bidStatus === '30') &&
                            scope.row.supplierBidStatus === '7' && !scope.row.effectDateFromFlag">等待竞价</div>
                        <div v-else-if="scope.row.bidStatus === '50' && scope.row.supplierBidStatus === '8'">已截止报名</div>
                        <div v-else-if="scope.row.bidStatus === '80' &&
                            (scope.row.supplierBidStatus === '7' || scope.row.supplierBidStatus === '8')">项目已结束</div>
                        <!-- <span v-else-if="scope.row.bidStatus === '53' &&
                            (scope.row.supplierBidStatus === '12' || scope.row.supplierBidStatus === '13')" v-has="'06010005'">
                            <el-button @click="sealbidPrice(scope.row)" size="mini" type="text">中标价格表盖章</el-button>
                        </span> -->

                    </template>
                </el-table-column>
            </el-table>
            <el-pagination slot="footer"
                class="text-right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="editorInfo.pageNo"
                :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="editorInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount">
            </el-pagination>
        </list-layout-paper>
        <el-dialog :visible.sync="showModal" title="列配置" @close="dialogClose">
            <configuration :checkedList="checkedList" :selectAllColumns="selectAllColumns" ref="dialog"
                @getTableConfigList="getTableConfigList" @tableConfigClose="tableConfigClose" :columnNum='columnNum'></configuration>
        </el-dialog>
        <!-- <Bid-Price-List :payTitle="'中标价格表盖章'" :originFlag="'1'" :MDialogshow="bidPayshow" :rowBidDialogData="bidPayshowRowData" @mdialogFn="mdialogFn"></Bid-Price-List> -->
        <MDialog :MDialogshow="MDialogshow" :rowBidDialogData="rowBidDialogData" @mdialogFn="mdialogFn"></MDialog>
        <payDialog :showPd="payshow" :myBidFlag="myBidFlag" :payDialogRowData="payDialogRowData" @payDialogEvent="payDialogEvent" :payTitle="'缴纳保证金'"></payDialog>
    </div>
</template>
<script>
import config from '@/config/user.env.js';
import { mapGetters } from 'vuex';
import ListLayoutPaper from '@/components/lots/listLayout/Paper';
import configuration from '@/components/otpPanel/configuration-list';
import mSelect from '@/components/lots/otpSelect2';
import MDialog from './BidDialog.vue';
import payDialog from './payDialog.vue';
// import BidPriceList from './BidPriceList.vue';
import { dictWithUrl } from '@/components/lots/api';
import { getList } from '../../../../lsrm/api/annoMana.js';
import { bidBidList, costOrderPay, existConfig, createIdfCode } from '../../../../lsrm/api/myBidding.js';
import { SRM_YES } from '../../../constant/constant.js';
export default {
    name: 'myBidding',
    components: { ListLayoutPaper, configuration, mSelect, MDialog, payDialog },
    data() {
        return {
            config,
            timestamp: 0,
            bidPayshow: false,
            bidPayshowRowData: {},
            MDialogshow: false,
            payshow: false,
            myBidFlag: false,
            resourceCode: '',
            payResult: {},
            payDialogRowData: {},
            rowBidDialogData: {},
            editorInfo: {
                pageNo: 1,
                pageSize: 10,
                bidName: '',
                bidNo: '',
                id: '',
                supplierBidStatus: '',
                bidStatus: ''
            },
            total: 0,
            bidList: [],
            loading: false,
            columnNum: 100,
            showModal: false,
            checkedList: '',
            selectAllColumns: [{
                prop: 'bidNo',
                label: '招标项目编码',
                width: '180'
            }, {
                prop: 'bidName',
                label: '招标项目名称',
                width: '280'
            }, {
                prop: 'bidStatusText',
                label: '项目状态',
                width: '180'
            }, {
                prop: 'supplierBidStatusText',
                label: '报名状态',
                width: '180'
            }],
            columnsList: [{
                prop: 'bidNo',
                label: '招标项目编码',
                width: '180'
            }, {
                prop: 'bidName',
                label: '招标项目名称',
                width: '280'
            }, {
                prop: 'bidStatusText',
                label: '项目状态',
                width: '180'
            }, {
                prop: 'supplierBidStatusText',
                label: '报名状态',
                width: '180'
            }],
            totalCount: 1,
            dictData: [],
            uniqueVisible: false,
            idfLoading: false,
            SRM_YES
        };
    },
    mounted() {
        this.queryDataFunc();
        dictWithUrl('BID_STATUS,SU_SUPPLIER_BID_STATUS').then(res => {
            this.dictData = res.data;
            this.loadData(this.editorInfo);
        });
        this.setConfigColumn();
        existConfig().then(res => {
            if (res && +res.code === 0) {
                this.uniqueVisible = res.data;
            }
        });
    },
    activated() {
        this.queryDataFunc();
        this.loadData(this.editorInfo);
    },
    methods: {
        clearData() {
            this.editorInfo = {
                pageNo: 1,
                pageSize: 10,
                bidName: '',
                bidNo: '',
                id: '',
                supplierBidStatus: '',
                supplierBidStatusList: [],
                bidStatus: ''
            };
        },
        queryDataFunc() {
            if (this.$store.state.supplier) {
                // LSP
                if (this.$route.query.bidStatus || this.$route.query.supplierBidStatus || this.$route.query.noticeCode) {
                    this.clearData();
                }
                if (this.$route.query.supplierBidStatus) {
                    this.editorInfo.supplierBidStatus = this.$route.query.supplierBidStatus;
                }
            }
            if (this.$route.query.noticeCode) {
                this.editorInfo.bidNo = this.$route.query.noticeCode;
            }
            if (this.$route.query.supplierBidStatusList) {
                this.editorInfo.supplierBidStatusList = this.$route.query.supplierBidStatusList.split(',');
                this.editorInfo.bidStatus = this.$route.query.bidStatus;
            }
            if (this.$route.query.bidStatus) {
                this.editorInfo.bidStatus = this.$route.query.bidStatus;
            }
        },
        buyBtn(row, type) {
            let returnUrl = '';
            if (config.apiUrl !== '/') {
                returnUrl = 'https:' + config.apiUrl + '/api-srm-web/public/bidPayCallBack';
            } else {
                returnUrl = 'https://anapi-sit.annto.com/api-srm-web/public/bidPayCallBack';
            }
            const par = {
                orderType: type,
                bidNo: row.bidNo,
                supplierCode: row.supplierCode,
                supplierName: row.supplierName,
                contactNumber: row.contactNumber,
                returnUrl: returnUrl
            };
            costOrderPay(par).then(res => {
                if (res && +res.code === 0) {
                    this.payResult = JSON.parse(res.data.payResult);
                    setTimeout(() => {
                        document.getElementById('formCommit').submit();
                    }, '500');
                }
            });
        },
        refreshFn() {
            this.queryDataFunc();
            this.loadData(this.editorInfo);
        },
        setConfigColumn() {
            const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
            this.deepMenu(menu);
            const pramas = {
                'moduleCode': this.resourceCode,
                'subjectType': 'tenderList'
            };
            getList.get(pramas).then(res => {
                if (res.data) {
                    const datas = res && res.data.configNameCn ? res.data.configNameCn.split(',') : [];
                    const columnsList = [];
                    if (!datas.length) {
                        this.selectAllColumns.map(data => {
                            columnsList.push(data);
                        });
                    } else {
                        datas.map(title => {
                            this.selectAllColumns.map(data => {
                                if (data.label === title) {
                                    columnsList.push(data);
                                }
                            });
                        });
                    }
                    this.columnsList = columnsList;
                    const arr = [];
                    this.columnsList.forEach(el => {
                        arr.push(el.label);
                    });
                    this.checkedList = arr.join(',');
                }
            });
        },
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    this.deepFunc(childrens);
                }
            }
        },
        deepFunc(childrens) {
            for (let i = 0; i < childrens.length; i++) {
                if (childrens[i].frontUrl === this.$route.path) {
                    this.resourceCode = childrens[i].resourceCode;
                } else {
                    this.deepMenu(childrens[i]);
                }
            }
        },
        searchFn() {
            this.editorInfo.pageNo = 1;
            delete this.editorInfo.supplierBidStatusList;
            this.loadData(this.editorInfo);
        },
        getBidStatus(value) {
            this.editorInfo.bidStatus = value;
        },
        getSupStatus(value) {
            this.editorInfo.supplierBidStatus = value;
        },
        sealFn(row) {
            this.MDialogshow = true;
            this.rowBidDialogData = row;
        },
        mdialogFn(type) {
            this.MDialogshow = false;
            this.bidPayshow = false;
            this.rowBidDialogData = {};
            if (type) {
                this.loadData(this.editorInfo);
            }
        },
        sealbidPrice(row) {
            this.bidPayshow = true;
            this.bidPayshowRowData = row;
        },
        bondFn(row) {
            this.payshow = true;
            this.myBidFlag = true;
            this.payDialogRowData = row;
        },
        payDialogEvent(data) {
            this.payshow = false;
            this.myBidFlag = false;
            this.payDialogRowData = {};
        },
        toBidding(row) {
            this.$router.push({
                name: 'myTender',
                query: {
                    bidNo: row.bidNo,
                    tenderCode: row.tenderCode,
                    supplierCode: row.supplierCode
                }
            });
        },
        handleRowDblClick(row) {
            if (row.supplierBidStatus === '1' || row.supplierBidStatus === '2' || row.supplierBidStatus === '14') {
                return;
            }
            this.$router.push({ name: 'tenderDetails', query: { id: row.id } });
        },
        loadData(serachObj) {
            serachObj.supplierCode = this.$store.state.supplier.supplierCode;
            serachObj.identificationCode = window.localStorage.getItem('bidIdentificationCode') || '';
            bidBidList(serachObj).then((res) => {
                if (res && +res.code === 0) {
                    this.timestamp = new Date(res.timestamp).getTime();
                    this.bidList = res.data.list;
                    this.totalCount = res.data.totalCount;
                    if (this.bidList.length > 0) {
                        this.conversionData(this.bidList);
                    }
                }
            });
        },
        colDispose() {
            this.showModal = true;
        },
        getTableConfigList(tabelConfigList, tabelConfigName) {
            this.showModal = false;
            const pramas = {
                'configName': tabelConfigName,
                'configNameCn': tabelConfigList,
                'subjectType': 'tenderList',
                'moduleCode': this.resourceCode
            };
            getList.post(pramas).then(() => {});
            const datas = tabelConfigList.split(',');
            const columnsList = [];
            datas.map(title => {
                this.selectAllColumns.map(data => {
                    if (data.label === title) {
                        columnsList.push(data);
                    }
                });
            });
            this.columnsList = columnsList;
        },
        tableConfigClose() {
            this.showModal = false;
        },
        dialogClose() {
            this.showModal = false;
        },
        handleCurrentChange(val) {
            this.editorInfo.pageNo = val;
            this.loadData(this.editorInfo);
        },
        handleSizeChange(val) {
            this.editorInfo.pageSize = val;
            this.loadData(this.editorInfo);
        },
        conversionData(list) {
            list.forEach(el => {
                el.bidStatusText = this.dictData.BID_STATUS[el.bidStatus];
                el.supplierBidStatusText = this.dictData.SU_SUPPLIER_BID_STATUS[el.supplierBidStatus];
                const depositEndTime = new Date(el.depositEndTime).getTime();
                el.depositEndTimeFlag = this.timestamp > depositEndTime; // 保证金截止时间
                if (!el.effectDateFrom) {
                    el.effectDateFromFlag = false;
                } else {
                    const effectDateFrom = new Date(el.effectDateFrom).getTime();
                    el.effectDateFromFlag = this.timestamp > effectDateFrom; // 报价开始时间
                }
            });
        },
        handleIdentify() {
            this.idfLoading = true;
            createIdfCode().then(res => {
                if (res && +res.code === 0) {
                    window.localStorage.setItem('bidIdentificationCode', res.data);
                    this.$message.success('报价唯一码已生成!');
                }
            }).finally(() => { this.idfLoading = false; });
        }
    },
    computed: {
        ...mapGetters(['menus', 'currentTenant', 'applicationCode'])
    }
};
</script>
<style lang="less">
.mybid-page {
    .margin-left {
        margin-left: 10px ;
    }

    .point {
        display:inline-block;
        width:8px;
        height: 8px;
        border-radius:100%;
    }

    .header-button {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        min-width:142px;
    }

    .btn-action {
        font-size: 12px;
        color: #666;
    }

    .buy-bidbook  {
        font-size: 12px;
        cursor: pointer;
        color: #00BCBF;
    }

    .tab-list.el-table {
        min-height: calc(~"100vh - 190px");
        max-height: calc(~"100vh - 190px");
    }

    .recall-text {
        color: #f96c5f;
    }
}
</style>
